import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function SponsorAverageHoldMonthsField({
  value,
  error,
  setValue,
  setError,
  ...rest
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setValue(newValue);
    if (!/^[0-9]*$/.test(newValue)) {
      setError('Average Hold Period must be an integer');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth>
        <TextField
          {...rest}
          label='Average Investment Hold Period (Months)'
          id='average_hold_months'
          aria-describedby='average-hold-months-helper-text'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
          variant='standard'
        />
        {error ? (
          <FormHelperText id='average-hold-months-helper-text'>
            {error}
          </FormHelperText>
        ) : (
          <FormHelperText id='average-hold-months-helper-text'>
            Enter the average hold period (in months) of the deals this sponsor
            manages
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
